import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import history from '../../helpers/history';
import { Layout } from 'antd';

const { Content } = Layout;

var languageMessages = window.appLocale.messages;

class BlankPage extends Component {

    componentWillMount() {
        var pathname = sessionStorage.getItem('pathname');
        sessionStorage.removeItem('pathname');
        history.replace(pathname);
    }

    render() {
        return (<Content className='main-container'><Helmet>
            <title>{languageMessages['title']}</title>
            <meta name="keywords" content={languageMessages['keywords']} />
            <meta name="description" content={languageMessages['description']} />

            <meta property="og:title" content={languageMessages['title']} />
            <meta property="og:url" content="https://us.quancept.com/" />
            <meta property="og:type" content="website" />
            <meta name="og:description" content={languageMessages['description']} />

            <meta property="twitter:url" content="https://us.quancept.com/" />
            <meta name="twitter:title" content={languageMessages['title']} />
            <meta name="twitter:description" content={languageMessages['description']} />
            <meta name="twitter:site" content="https://us.quancept.com/" />
        </Helmet></Content>);
    }
}

export { BlankPage as default }